module.exports = __webpack_public_path__ + "img/trunk_n.00b72c08.png";